import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FlatButton from 'components/consumer/FlatButton';
import useIsHoverDevice from 'hooks/useIsHoverDevice';

const FlatButtonFilters = ({
  customFinalButton,
  isSelectedButtonFilled = false,
  items,
  loading = false,
  onMouseEnter,
  onMouseLeave,
  scrollOnMobile = false,
  selectedItem,
  setSelectedItem,
  showMarginBottom = true,
  variant,
}) => {
  const isHoverDevice = useIsHoverDevice();

  if (loading) {
    return (
      <div
        className={classNames(
          'flex flex-wrap [&>*]:mr-[5px] [&>*:last-child]:mr-0',
          {
            '[&_>_*]:mb-1.5': showMarginBottom,
          }
        )}
      >
        {[0, 1, 2, 3, 4, 5].map(index => (
          <FlatButton loading key={index} />
        ))}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'flex flex-wrap [&>*]:mr-[5px] [&>*:last-child]:mr-0',
        {
          'max-[1023px]:!flex-nowrap max-[1023px]:!whitespace-nowrap max-[1023px]:!pl-[22px] max-[1023px]:!pr-[470px]':
            variant === 'PDPSelectUpholstery',
          '[&>*]:mb-1.5': showMarginBottom,
          'max-[767px]:flex-nowrap max-[767px]:-ml-5 max-[767px]:-mr-5 max-[767px]:pl-5 max-[767px]:overflow-auto': scrollOnMobile,
        }
      )}
    >
      {items.map(({ color, id, label }) => (
        <FlatButton
          key={id}
          isSelected={
            typeof selectedItem === 'string'
              ? id === selectedItem
              : selectedItem?.includes(id)
          }
          scrollOnMobile={scrollOnMobile}
          onClick={() => setSelectedItem(id)}
          onMouseEnter={
            isHoverDevice && !!onMouseEnter ? () => onMouseEnter(id) : undefined
          }
          onMouseLeave={
            isHoverDevice && !!onMouseLeave ? () => onMouseLeave(id) : undefined
          }
          color={color}
          isSelectedButtonFilled={isSelectedButtonFilled}
        >
          {label}
        </FlatButton>
      ))}

      {customFinalButton}

      {!!scrollOnMobile && <FlatButton spacer scrollOnMobile />}
    </div>
  );
};

FlatButtonFilters.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      id: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        .isRequired,
    })
  ),
  loading: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  scrollOnMobile: PropTypes.bool,
  selectedItem: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  setSelectedItem: PropTypes.func,
  showMarginBottom: PropTypes.bool,
  variant: PropTypes.oneOf(['PDPSelectUpholstery']),
  isSelectedButtonFilled: PropTypes.bool,
};

export default FlatButtonFilters;
